import React from "react";
import DocumentPermission from "components/Tvendo/Setting/Print/DocumentPermission/DocumentPermission";

export default function () {
  return <DocumentPermission />;
}
